const config = {
  // Set to true when ready to launch the blog publicly
  blogEnabled: true,

  // Set to false to hide the Projects section on the homepage
  projectsSectionEnabled: false,
};

export default config;
